import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CoinMarket from '../components/exchange/CoinMarket';

const mapStateToProps = (state) => ({
  setting: state.setting,
  coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CoinMarket));
